module.exports = __webpack_public_path__ + "media/img/event/sponsor/artisans-haven_logo-b157bc30a720027389b5685151ff8b50.png";